import { useEffect, useState } from "react";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import Html from "./html";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";

const Cards = () => {
  const searchState = { data: "" }
  const user = useSelector((state) => state.user)
  const [filters, setFilter] = useState({ page: 1, count: 10, search: "", categoryId: "", subCategoryId: "", envelopeId: "" })
  const [data, setData] = useState([])
  const [total, setTotal] = useState(0)
  const [categories, setCategories] = useState([])
  const [subCategories, setSubCategories] = useState([])
  const [envelopes, setEnvelopes] = useState([])
  const history = useNavigate()

  useEffect(() => {
    setFilter({ ...filters, search: searchState.data })
    getData({ search: searchState.data })
    getAllCategories()
    getAllSubCategories()
    getAllEnvelopes()
  }, [])

  const getData = (p = {}) => {
    loader(true)
    let filter = { ...filters, ...p }
    ApiClient.get("card/listing", filter).then((res) => {
      if (res.success) {
        setData(res?.data)
        setTotal(res.total)
      }
      loader(false)
    })
  }

  const getAllCategories = () => {
    ApiClient.get(`category/listing`).then(res => {
      if (res.success) {
        setCategories(res?.data?.map((item) => {
          return ({ id: item?.id || item?._id, name: item?.name })
        }))
      }
    })
  }
  const getAllSubCategories=(id="")=>{
    ApiClient.get(`category/sub-cat/list?status=active&categoryId=${id}`).then(res => {
      if (res?.success) {
        setSubCategories(res?.data?.map((item) => {
          return ({ id: item?.id || item?._id, name: item?.name })
        }))
      }
    })
  }

  const getAllEnvelopes=()=>{
    ApiClient.get(`envelope/listing`).then(res=>{
      if(res.success){
        setEnvelopes(res?.data?.map((item)=>{
          return ({ id: item?.id || item?._id, name: item?.name })
        }))
      }
    })
  }

  const clear = () => {
    let f = {
      search: "",
      status: "",
      categoryId: "",
      subCategoryId: "",
      envelopeId: "",
    };
    setFilter({ ...filters, ...f });
    getData({ ...f });
    getAllSubCategories()
  }

  const filter = (p = {}) => {
    let f = {
      ...p,
    };
    setFilter({ ...filters, ...f });
    getData({ ...f });
  }

  const deleteCard = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to delete this card`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        loader(true);
        ApiClient.delete(`card/delete?id=${id}`).then((res) => {
          if (res.success) {
            clear();
          }
          loader(false);
        });
      }
    });
  }

  const pageChange = (e) => {
    setFilter({ ...filters, page: e });
    getData({ page: e });
  }

  const count = (e) => {
    setFilter({ ...filters, count: e });
    getData({ ...filters, count: e });
  }

  const changestatus = (e, key) => {
    setFilter({ ...filters, [key]: e });
    getData({ [key]: e });
  }

  const statusChange = (itm) => {
    let status = "active";
    if (itm.status == "active") status = "deactive";
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${status == "active" ? "Activate" : "Deactivate"
        } this card?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        loader(true)
        ApiClient.put("card/status/change", { id: itm?._id || itm?.id, status }).then(res => {
          if (res.success) {
            getData()
          }
          loader(false)
        })
      }
    })
  }

  const edit = (id) => {
    history(`/card/edit/${id}`);
  }

  const view = (id) => {
    let url = `/card/detail/${id}`;
    history(url);
  }

  const isAllow = (key = "") => {
    if (user?.role?.name == "admin") return true
    let permissions = user.Permission;
    let value = permissions?.[key];
    return value;
  }

  const handleSearch = (e) => {
    setFilter({ ...filters, search: e.target.value });
    if (e.target.value === "") {
      getData({ search: "" })
    }
  }

  const handleCategory=(e)=>{
    getAllSubCategories(e||"")
    setFilter({ ...filters, categoryId: e || "", subCategoryId: "" });
    getData({ categoryId: e || "", subCategoryId: "" });
  }

  return (
    <>
      <Html
        edit={edit}
        view={view}
        clear={clear}
        isAllow={isAllow}
        count={count}
        pageChange={pageChange}
        deleteCard={deleteCard}
        filters={filters}
        setFilter={setFilter}
        filter={filter}
        data={data}
        total={total}
        statusChange={statusChange}
        changestatus={changestatus}
        handleSearch={handleSearch}
        categories={categories}
        subCategories={subCategories}
        handleCategory={handleCategory}
        envelopes={envelopes}
      />
    </>
  );
};

export default Cards;
